<template>
  <div class="modal-wrapper">
    <modal-header :title="title" :subtitle="subtitle" :on-modal-close="close" />
    <div class="homebase-modal-body pb-5 px-5">
      <div v-if="isLoading"><modal-loading /></div>
      <div v-else>
        <div v-if="isSuccess">
          <modal-success :description="successMsg" v-slot:subTitle >
            <div v-if="showSubtitle">
              <router-link
                :to="{ path: 'events' }"
                @click.native="handleViewAllEvent()"
                class="subTitle-link"
              >
                <span>View all</span> 
              </router-link>
              <span class="subTitle-description">your events and add them to your calendar</span>
            </div>
          </modal-success> 
        </div>
        <div v-else class="row">
          <div class="col-12 pb-3">
            <div class="alert alert-error" v-if="isErrored">
              {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
            </div>
          </div>
          <div
            class="col-6"
            v-for="(inputGroupData, i) in inputGroups"
            :key="i"
          >
            <div class="pb-3">
              <edit-interests-input-group
                ref="inputGroupRef"
                :title="inputGroupData.title"
                :loaded-inputs="inputGroupData.inputs"
                :column-class="'col-12'"
                :type="'events'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isLoading"
      class="d-flex flex-column flex-sm-row justify-content-end homebase-modal-footer px-5 pb-5"
    >
      <div
        v-if="!isSuccess"
        class="homebase-btn-secondary mt-2 ml-sm-4"
        @click="close"
      >
        Cancel
      </div>
      <div
        v-if="!isSuccess"
        class="homebase-btn-primary mt-2 ml-sm-4"
        @click="save"
      >
        Save
      </div>
      <div
        v-if="isSuccess"
        class="homebase-btn-primary mt-2 ml-sm-4"
        @click="close"
      >
        Done
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import ModalHeader from "../modals/ModalHeader";
import ModalLoading from "../modals/ModalLoading";
import ModalSuccess from "../modals/ModalSuccess";
import EditInterestsInputGroup from "@/components/homebase/newsByInterests/EditInterestsInputGroup";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "edit-interests-modal",
  props: ["topics", "showSubtitle"],
  mixins: [HomebaseMixpanelMixin],
  components: {
    ModalLoading,
    ModalHeader,
    ModalSuccess,
    EditInterestsInputGroup,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      isSuccess: false,
      title: "",
      subtitle: "",
      successMsg: "Your interests have been saved.",
      inputGroups: null,
    };
  },
  created() {
    this.initializeModal();
    this.setInputGroups();
  },
  methods: {
    initializeModal() {
      this.setDefaultHeaderConfig();
    },

    setDefaultHeaderConfig() {
      this.title = "Events based on your interests";
      this.subtitle =
        "Start curating your events based on what you are interested in";
    },

    setSavingHeaderConfig() {
      this.title = "Saving your interests...";
      this.subtitle = null;
    },

    getInputGroups() {
      if (!this.topics || this.topics.length === 0) return [];

      let categoryToTopics = this.topics.reduce((map, topic) => {
        map[topic.category] = [...(map[topic.category] || []), topic];
        return map;
      }, {});

      let result = [];
      for (const [category, topics] of Object.entries(categoryToTopics)) {
        result.push({
          title: category,
          inputs: topics,
        });
      }

      return result;
    },

    setInputGroups() {
      this.inputGroups = this.getInputGroups();
    },

    processSelections() {
      let result = [];
      let inputGroups = this.$refs.inputGroupRef;

      inputGroups.forEach((group) => {
        let formattedSelections = group.processSelections();
        result = result.concat(formattedSelections);
      });

      return result;
    },

    formatSelections(selections) {
      return selections.map((s) => {
        return {
          id: s.id,
          subscribe: s.subscribe,
        };
      });
    },

    async save() {
      this.isLoading = true;
      this.setSavingHeaderConfig();
      let selections = this.processSelections();
      let formattedSelections = this.formatSelections(selections);
      
      try {
        let res = await api.updateEventsTopicsSubscriptions(formattedSelections);
        if (res.data.data.subscribeToTopics.error) {
          throw "Error";
        } else {
          this.isSuccess = true;
          this.$parent.$emit("interestsSaved");
          this.setDefaultHeaderConfig();
        }

      } catch (e) {
        this.isErrored = true;
      }

      this.isLoading = false;
    },

    close() {
      this.$emit("update:modelValue", false);
    },

    handleViewAllEvent() {
      this.trackViewAllClick('View all events selected');
      this.close();
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: relative;
}
.homebase-modal-body {
  padding-top: 34px;
  min-height: 300px;
}
.subTitle-link {
  font-size: 16px;
  font-family: artifaktElementBold;
  cursor: pointer;
  text-decoration: none;
}
.subTitle-description {
  font-size: 16px;
  padding-left: 3px;
  font-family: artifaktElementBold;
}
</style>
